/* ============================================================================
   Glitch / decode text effect  —  WEBEXP
   - Headings, subheadings & product titles decode as they scroll into view
   - Nav menu links (desktop + mobile drawer) decode when they become visible,
     and re-decode on hover
   Vanilla JS, no dependencies. Ported from the SPLY theme's scramble effect.

   Config (optional) via window.__GLITCH_CFG in theme.liquid:
     { headings:true, menu:true, selector:"<css override for headings>" }
   Opt any element out with  data-no-glitch.
   ========================================================================== */
(function () {
  "use strict";

  var CFG = window.__GLITCH_CFG || {};
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  var GLYPHS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  function rnd() { return GLYPHS.charAt(Math.floor(Math.random() * GLYPHS.length)); }
  // Keep punctuation AND all whitespace (incl. line breaks) fixed, so multi-line
  // headings never collapse into one line while scrambling.
  function isFixed(c) { return c === "-" || c === "/" || c === "." || /\s/.test(c); }

  function plan(t) {
    var q = [];
    for (var i = 0; i < t.length; i++) {
      var c = t.charAt(i), fx = isFixed(c);
      q.push({ c: c, fx: fx, end: fx ? 0 : Math.round(i * 1.7) + 5 + Math.floor(Math.random() * 6) });
    }
    return q;
  }
  function prescramble(el, t) {
    var o = "";
    for (var i = 0; i < t.length; i++) o += isFixed(t.charAt(i)) ? t.charAt(i) : rnd();
    el.textContent = o;
  }
  function decode(el, t) {
    if (el._glIv) { clearInterval(el._glIv); el._glIv = null; }
    var q = plan(t), f = 0;
    el._glIv = setInterval(function () {
      var o = "", d = 0;
      for (var j = 0; j < q.length; j++) {
        var it = q[j];
        if (it.fx || f >= it.end) { o += it.c; d++; } else { o += rnd(); }
      }
      el.textContent = o; f++;
      if (d === q.length) { clearInterval(el._glIv); el._glIv = null; el.textContent = t; }
    }, 32);
  }

  // Only rewrite plain-text runs; never destroy nested markup. Descends into a
  // single wrapper that holds all the text (e.g. <h3 class="product-title"><a>Title</a></h3>).
  function textHost(el) {
    if (!el) return null;
    if (el.childElementCount === 0) return el;
    var s = el.querySelector(".menu-item-text");
    if (s && s.childElementCount === 0) return s;
    if (el.childElementCount === 1) {
      var only = el.firstElementChild;
      if (only && only.childElementCount === 0 &&
          (only.textContent || "").trim() === (el.textContent || "").trim()) return only;
    }
    return null;
  }

  // Decode when the element actually becomes visible — so off-screen items
  // (below the fold, or inside a closed mobile menu drawer) fire when revealed.
  var io = ("IntersectionObserver" in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var host = en.target._glHost;
      io.unobserve(en.target);
      if (host) decode(host, host._glFinal);
    });
  }, { rootMargin: "0px 0px -8% 0px", threshold: 0.15 }) : null;

  function arm(el) {
    if (!el || el._glReady) return null;
    if (el.closest("[data-no-glitch]")) return null;
    var host = textHost(el);
    if (!host) return null;
    var t = (host.textContent || "").trim();
    if (!t || t.length < 2) return null;
    el._glReady = 1; host._glFinal = t; el._glHost = host;
    if (io) { prescramble(host, t); io.observe(el); } else { decode(host, t); }
    return host;
  }

  var HEAD_SEL = ".main-content h1, .main-content h2, .main-content h3, .main-content h4, " +
    ".main-content .sub-title, .main-content .title__heading, " +
    // product titles — PDP + collection / featured cards (any container):
    ".product-single__title, .product-title, .product-card__name, .name-products, .item-product-title, " +
    ".title-product, .item-title, .collection-grid__item-title, .product-sidebar__name-link";

  var MENU_SEL = ".main-menu__nav-item > a, .main-menu__nav-item > .mm-nav__wrapper > a, " +
    ".menu-mobile__nav-item > a, .menu-mobile__nav-item > .mm-nav__wrapper > a, .menu__link";

  function initHeadings() {
    if (CFG.headings === false) return;
    var sel = (CFG.selector && String(CFG.selector).trim()) || HEAD_SEL;
    var els;
    try { els = document.querySelectorAll(sel); } catch (e) { els = document.querySelectorAll(HEAD_SEL); }
    for (var i = 0; i < els.length; i++) arm(els[i]);
  }

  function initMenu() {
    if (CFG.menu === false) return;
    var links = document.querySelectorAll(MENU_SEL);
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.classList.contains("mm-nav__prev")) continue;   // skip "back" links in mobile drawer
      if (arm(a)) {
        a.addEventListener("mouseenter", function () {
          var h = this._glHost;
          if (h && !h._glIv) decode(h, h._glFinal);
        });
      }
    }
  }

  function run() { initHeadings(); initMenu(); }

  // Hold until the preloader fades, otherwise the decode plays hidden behind it.
  var started = false;
  function boot() {
    if (started) return;
    if (window.__glPreloaderActive) {
      document.addEventListener("gl:preloaderdone", function () { if (!started) { started = true; run(); } }, { once: true });
      setTimeout(function () { if (!started) { started = true; run(); } }, 9000);
    } else { started = true; run(); }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  document.addEventListener("shopify:section:load", function () { run(); });

  // Catch content added after load — async product recommendations, carousel clones
  // (infinite-loop sliders duplicate slides), quick view, load-more — so those titles glitch too.
  var moT = null;
  function reScan() {
    if (!started) return;              // the post-preloader run() will scan what's present
    if (moT) return;
    moT = setTimeout(function () { moT = null; run(); }, 250);
  }
  try {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { reScan(); return; }
      }
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();